import { render, staticRenderFns } from "./detail-component-text.vue?vue&type=template&id=ba86f0f8&scoped=true"
import script from "./detail-component-text.vue?vue&type=script&lang=ts"
export * from "./detail-component-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba86f0f8",
  null
  
)

export default component.exports